import commonUtil from "@/components/commonutil";
import processorTemplateUtil from "@/components/pc/setting/ai-app/AiAppSettingUtil";

export default {
    TYPE_PROCESSOR : 'processor',
    TYPE_SERVICE_INFORMATION : 'service_information',

    SERVICE_NAME_GIGARAKU_CAMERA : 'GigarakuCamera',

    methods: {
        getLocaledText(item) {
            return processorTemplateUtil.getLocaledText(this.$i18n, item);
        },

        getSettingTitle(item) {
            return commonUtil.getMessageText(this.$i18n, 'title_ai_setting_title').replace("{processorName}",processorTemplateUtil.getLocaledText(this.$i18n, item));
        },

        getNameOfSelectedValue(item) {
            return processorTemplateUtil.getNameOfSelectedValue(this.$i18n, item);
        },

        getHelpHtmlUrl(helpItem) {
            return processorTemplateUtil.getHelpHtmlUrl(this.$i18n, helpItem)
        },

        getDefaultIconUrl() {
            return processorTemplateUtil.getDefaultIconUrl();
        },

        existsContents(processor) {
            return processorTemplateUtil.shownContentsExist(processor);
        },

        isVisible(item) {
            return processorTemplateUtil.judgeVisible(item);
        },

        hasSelection(item) {
            return processorTemplateUtil.needSelection(item);
        }
    }
}
